import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[kui-side-panel-label]',
})
export class KuiSidePanelLabelDirective {
  @HostBinding('class.mb-0') noMarginBottom = true;
}
